import checkVisible from './_check-visible.js';

const $ = window.jQuery;

class AnimationGroup {
  constructor($element, options) {
    const defaults = {
      itemSelector: '.animate-item',
      delay: 0,
      duration: 600,
    };
    this.config = $.extend({}, defaults, options || {});
    this.$element = $element;
    this.$items = this.$element.find(this.config.itemSelector);
    this.delay = this.config.delay;
    this.duration = this.config.duration;
    this.timeoutCounter = 0;

    this.addListeners();
  }

  addListeners() {
    $(document).ready(() => {
      this.startAnimate('animate', 'animate-start', 'animate-end', this.delay);
    });
  }

  startAnimate(animateClass, animateStartClass, animateEndClass, delay = 0) {
    window.setTimeout(() => {
      this.$element.addClass(animateStartClass);
      if (this.$items.length) {
        this.animateItem(animateClass, () => {
          this.endAnimate(animateStartClass, animateEndClass);
        });
      } else {
        this.endAnimate(animateStartClass, animateEndClass);
      }
    }, delay);
  }

  endAnimate(animateStartClass, animateEndClass) {
    this.$element.removeClass(animateStartClass).addClass(animateEndClass);
  }

  animateItem(animateClass, callback) {
    let itemIndex = this.timeoutCounter++;
    let $item = this.$items.eq(itemIndex);
    let duration = $item.attr('data-duration-override')
      ? $item.attr('data-duration-override')
      : this.duration;
    $item.addClass(animateClass);
    if (itemIndex < this.$items.length) {
      window.setTimeout(() => {
        this.animateItem(animateClass, callback);
      }, duration);
    } else {
      typeof callback === 'function' && callback();
    }
  }
}

const animationGroups = [];

if ($('.animation-group').length) {
  $('.animation-group').each(function (index, element) {
    const $element = $(element);
    let options = {};
    if ($element.attr('data-item-selector')) options.itemSelector = $element.attr('data-item-selector');
    if ($element.attr('data-delay')) options.delay = $element.attr('data-delay');
    if ($element.attr('data-duration')) options.duration = $element.attr('data-duration');
    animationGroups.push(new AnimationGroup($element, options));
  });
} else {
  setInterval(function () {
    checkVisible();
  }, 10);
}
